// returns a boolean if the editorState contains a block with type blockType
export default function hasBlockWithType(editorState, blockType) {
  const blockMap = editorState.getCurrentContent().getBlockMap();
  return blockMap.filter(block => block.getType() === blockType).count() > 0;
}
